import type { PropsWithChildren } from "react";
import { Link, useLocation } from "react-router-dom";

import { adminRoutes } from "~/routes/routes";

import { Header } from "../Header";

export const SalesLayout: React.FC<PropsWithChildren> = ({ children }) => {
	const location = useLocation();

	return (
		<main className="flex flex-1 flex-col bg-slate-100 overflow-hidden">
			<Header />

			<div className="flex gap-4 p-5 pb-0">
				<Link
					to={adminRoutes.sales.subscriptions}
					data-selected={location.pathname.includes("assinaturas")}
					className="rounded-md px-3 py-1 bg-gpa-blue-500/10
          data-[selected=true]:bg-gpa-blue-500
          data-[selected=true]:text-white
          hover:bg-opacity-30 data-[active=true]:bg-opacity-30"
				>
					Assinaturas
				</Link>
				<Link
					to={adminRoutes.sales.charges}
					data-selected={location.pathname.includes("cobrancas")}
					className="rounded-md px-3 py-1 bg-gpa-blue-500/10
          data-[selected=true]:bg-gpa-blue-500
          data-[selected=true]:text-white
          hover:bg-opacity-30 data-[active=true]:bg-opacity-30"
				>
					Cobranças
				</Link>
				<Link
					to={adminRoutes.sales.plans()}
					data-selected={location.pathname.includes("planos")}
					className="rounded-md px-3 py-1 bg-gpa-blue-500/10
          data-[selected=true]:bg-gpa-blue-500
          data-[selected=true]:text-white
          hover:bg-opacity-30 data-[active=true]:bg-opacity-30"
				>
					Modelos de Assinatura
				</Link>
				<Link
					to={adminRoutes.sales.discounts}
					data-selected={location.pathname.includes("descontos")}
					className="rounded-md px-3 py-1 bg-gpa-blue-500/10
          data-[selected=true]:bg-gpa-blue-500
          data-[selected=true]:text-white
          hover:bg-opacity-30 data-[active=true]:bg-opacity-30"
				>
					Descontos
				</Link>
				<Link
					to={adminRoutes.sales.courtesies}
					data-selected={location.pathname.includes("cortesias")}
					className="rounded-md px-3 py-1 bg-gpa-blue-500/10
          data-[selected=true]:bg-gpa-blue-500
          data-[selected=true]:text-white
          hover:bg-opacity-30 data-[active=true]:bg-opacity-30"
				>
					Cortesias
				</Link>
			</div>
			{children}
		</main>
	);
};
